import PropTypes from "prop-types";

import { Box, Typography } from "@mui/material";

export const TwoLineCell = ({ primary, secondary }) => {
  return (
    <Box
      sx={{
        py: 0.5,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
      }}
    >
      <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
        {primary}
      </Typography>
      {secondary && (
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            lineHeight: 1.2
          }}>
          {secondary}
        </Typography>
      )}
    </Box>
  );
};

TwoLineCell.propTypes = {
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.node,
};
